import React from 'react'
import {logs} from "./data"

const index = () => {
  return (
 <div className='w-full h-full bg-white p-4'>
       <div className="space-y-6 p-6 max-w-3xl mx-auto ">
       {logs.map((log, index) => (
         <div key={index} className="rounded-2xl  " dir='ltr'>
           <div className="flex flex-col items-start justify-between mb-2 border-b-2 ">
             <h2 className="text-xl font-semibold">{log.title}</h2>
            <div className='w-full flex justify-between items-center'>
               <span className="text-sm text-gray-500">{log.date}</span>
               <span className="text-lg text-gray-900 font-bold">version _ {log.version}  </span>
            </div>
           </div>
           <ul className="list-disc list-inside space-y-1 text-gray-700 bg-neutral-10 p-2" dir='rtl'>
             {log.changes.map((change, idx) => (
               <li key={idx}>{change}</li>
             ))}
           </ul>
         </div>
       ))}
     </div>
 </div>
  )
}

export default index